import React, { useState } from "react";
import { routeMatches } from "storefront/lib/route";
import useIsClient from "storefront/hooks/ClientRendering/useIsClient";
import useAuthentication from "storefront/hooks/useAuthentication";
import Warning from "storefront/components/Icons/Information/Warning";
import Button from "storefront/components/Button";
import ButtonLink from "storefront/components/ButtonLink";
import Checkbox from "storefront/components/Checkbox";
import {
  AlertModal,
  AlertModalContent,
  AlertModalTitle,
  AlertModalDescription,
} from "storefront/components/ModalV2/AlertModal";
import acknowledgeViolation from "storefront/GrailedAPI/v1/Users/Violations/acknowledge";
import FlashManager from "storefront/lib/flash/FlashManager";
import styles from "./ViolationModal.module.scss";

const ViolationModal = () => {
  const mounted = useIsClient();
  const [acknowledged, setAcknowledged] = useState(false);
  const [checked, setChecked] = useState(false);
  const auth = useAuthentication();

  if (auth.type !== "Authenticated") return null;

  const { user } = auth;

  const handleAccept = () => {
    acknowledgeViolation(user.id).catch(() => {
      FlashManager.getInstance().alert(
        "Something went wrong. Please try again or contact support.",
      );
    });
    setAcknowledged(true);
  };

  if (mounted && routeMatches("/about/terms")) return null;

  return (
    <AlertModal open={user.hasUnacknowledgedViolations && !acknowledged}>
      <AlertModalContent>
        <div className={styles.wrapper}>
          <div className={styles.iconWrapper}>
            <Warning className={styles.warningIcon} />
          </div>

          <AlertModalTitle className={styles.title}>
            Your account has been flagged for offsite activity
          </AlertModalTitle>

          <AlertModalDescription className={styles.description}>
            Offsites are attempts to conduct a transaction outside the Grailed
            platform. They may include sharing contact information, social media
            handles, or referrals to other platforms.
          </AlertModalDescription>

          <Checkbox
            id="violation-acknowledgement"
            value="acknowledged"
            checked={checked}
            onChange={() => setChecked((prev) => !prev)}
            className={styles.acknowledgementBox}
          >
            I acknowledge that I have read the Grailed Terms of Service and that
            any further violations may result in account restrictions, reduced
            listing visibility, suspension, or removal from Grailed.
          </Checkbox>

          <div className={styles.buttons}>
            <ButtonLink
              href="/about/terms"
              target="_blank"
              rel="noopener noreferrer"
              size="large"
              variant="secondary"
            >
              Terms Of Service
            </ButtonLink>
            <Button
              disabled={!checked}
              onClick={handleAccept}
              size="large"
              variant="primary"
            >
              Accept
            </Button>
          </div>
        </div>
      </AlertModalContent>
    </AlertModal>
  );
};

export default ViolationModal;
